import { connect } from 'react-redux';
import React from 'react';
import { loadStatus } from '../../utility/QBDownload';
import isFeedsFast from '../../utility/isFeedsFast';
import { isLoadKuaiBao, getBarStyleValue } from '../../utility/PageConfigDataForShare';

import './Bar.scss';
const renderBar = (barStyleValue, options) => {
  if (barStyleValue === 'test_1' || barStyleValue === 'test_2') {
    return (
      <div className={`mod-download-tips-con ${options.show ? 'active' : ''}`}>
        <div className="mod-new-right">
          {options.image ? (
            <div className="mod-new-image">
              <img src={options.image} alt="" />
            </div>
          ) : (
            <div className={options.logo}></div>
          )}
        </div>
        <div className="mod-new-left">
          <p className="mod-new-title">{options.title}</p>
          {barStyleValue === 'test_2' ? (
            <p className="mod-new-tag">
              <span>{options.btnText}</span>
              <i></i>
            </p>
          ) : (
            <p className="mod-new-btn">打开</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`mod-download-tips-con ${options.show ? 'active' : ''}`}>
      <div className="mod-new-left">
        <p className="mod-new-title">{options.title}</p>
        <p className="mod-new-tag">
          <span>{options.btnText}</span>
          <i></i>
        </p>
        {barStyleValue === 'test_3' && <p className="mod-new-tag-bg"></p>}
      </div>
      <div className="mod-new-right">
        {options.image ? (
          <div className="mod-new-image">
            <img src={options.image} alt="" />
          </div>
        ) : (
          <div className={options.logo}></div>
        )}
      </div>
    </div>
  );
};

class BarForShare extends React.PureComponent<{
  title: string,
  image: string,
  onIndicatorCLick: Function,
  show: boolean,
}> {
  static defaultProps = {
    title: 'QQ浏览器－看热点',
    summary: '6亿资讯用户的选择',
    show: true,
    status: loadStatus.DEFAULT,
    installed: false,
  };
  render() {
    const isFF = isFeedsFast();
    let btnText = isFF ? '打开天天快报极速版阅读' : '打开QQ浏览器阅读';
    let logo = isFF ? 'fflogo logo' : 'logo';

    // 拉新拉活看点快报
    const isKuaibao = isLoadKuaiBao();
    if (isKuaibao) {
      btnText = '打开看点快报阅读';
      logo = 'kblogo logo';
    }
    const title = this.props.title || '';

    // 命中profile的bar样式
    const barStyleValue = isKuaibao ? getBarStyleValue() : '';
    const options = {
      image: this.props.image,
      show: this.props.show,
      logo,
      btnText,
      title,
    };

    return (
      <div className="mod-download" onClick={this.props.onIndicatorCLick}>
        <div className="mod-download-tips">
          <div className="mod-download-fixer">{renderBar(barStyleValue, options)}</div>
        </div>
      </div>
    );
  }
}

export default connect(({ sharepage: { tagText } }) => ({ tagText }))(BarForShare);
